import axios from 'axios';
import { req,reqByJson } from './axiosFun';

/**
 * 支付配置信息
 **/
// 支付配置信息-获取支付配置信息列表
export const queryByUserId = (params) => { return req("post", "/fieldmanagesystem/message/queryByUserId", params)  };
export const search = (params) => { return req("post", "/fieldmanagesystem/message/search", params)  };
export const sendMessage = (params) => { return req("post", "/fieldmanagesystem/message/postMessage", params)  };
export const deleteMessages = (params) => { return reqByJson("post", "/fieldmanagesystem/message/deleteMessages", params)  };
export const markToRead = (params) => { return reqByJson("post", "/fieldmanagesystem/message/markToRead", params)  };





// WEBPACK FOOTER //
// ./src/api/message.js